import { PermissionRules, PERMISSIONS } from '@teamworksdev/influencer/core';
import { isTeamUser } from './roles';

const hasMediaRequestsRead = PermissionRules.hasAnyTeamPermission([
	PERMISSIONS.TEAM_ADMIN,
	PERMISSIONS.MEDIA_REQUEST_READ,
	PERMISSIONS.MEDIA_REQUEST_WRITE,
]);

const hasMediaRequestsWrite = PermissionRules.hasAnyTeamPermission([
	PERMISSIONS.TEAM_ADMIN,
	PERMISSIONS.MEDIA_REQUEST_WRITE,
]);

const accessContentTasks = PermissionRules.and(
	isTeamUser,
	hasMediaRequestsRead,
);

const canCreateContentTask = PermissionRules.and(
	isTeamUser,
	hasMediaRequestsWrite,
);

export {
	hasMediaRequestsRead,
	hasMediaRequestsWrite,
	accessContentTasks,
	canCreateContentTask,
};

